import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { LocationModel } from '../models/location';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiProvider } from '../providers/api.provider';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private currentLocationSubject: BehaviorSubject<LocationModel[]>;
  public locationSubject: BehaviorSubject<any>;
  public loadingInProgress: BehaviorSubject<boolean>;
  public currentLocation: Observable<LocationModel[]>;
  public dataSource: MatTableDataSource<LocationModel>;
  public RouteID: number = 0;
  constructor(private apiProvider: ApiProvider) {
    this.locationSubject = new BehaviorSubject<LocationModel>(null);
    this.loadingInProgress = new BehaviorSubject<boolean>(null);
  }

  public get locationValue(): any {
    return this.locationSubject.value;
  }

  public setLocation(value: any) {
    this.locationSubject.next(value);
  }

  public get currentLocationValue(): LocationModel[] {
    return this.currentLocationSubject.value;
  }

  public get getLoadingInProgress(): boolean {
    return this.loadingInProgress.value;
  }

  public setLoadingInProgress(value: boolean) {
    this.loadingInProgress.next(value);
  }

  public attachPriority(
    event: any,
    OldPriority: number,
    PostalCode: string
  ): void {
    const doneElements = document.querySelectorAll('.loading-submit');
    doneElements.forEach(function (doneItem: HTMLElement) {
      doneItem.style.display = 'none';
    });

    const loading: HTMLElement = document.querySelector(
      '#loading' + PostalCode
    );
    loading.style.display = 'block';

    this.apiProvider
      .AttachLocationPostalPriority(
        this.RouteID,
        OldPriority,
        Number(event.target.value),
        PostalCode
      )
      .subscribe(() => {
        loading.style.display = 'none';
        const doneElement: HTMLElement = document.querySelector(
          '#done' + PostalCode
        );
        doneElement.style.display = 'block';
      });
  }

  public updatePriority(
    event: any,
    PostalCodeDigit: string,
    OldPriority: number,
    PostalCode: string
  ): void {
    const doneElements = document.querySelectorAll('.loading-submit');
    doneElements.forEach(function (doneItem: HTMLElement) {
      doneItem.style.display = 'none';
    });

    const loading: HTMLElement = document.querySelector(
      '#loading' + PostalCode
    );
    loading.style.display = 'block';

    this.apiProvider
      .UpdateLocationPostalPriority(
        this.RouteID,
        OldPriority,
        Number(event.target.value),
        PostalCodeDigit
      )
      .subscribe(() => {
        loading.style.display = 'none';
        const doneElement: HTMLElement = document.querySelector(
          '#done' + PostalCode
        );
        doneElement.style.display = 'block';
      });
  }

  async initialiseLocation(digitCount: number) {
    this.setLoadingInProgress(true);
    await this.apiProvider
      .GetLocationPostalCode(this.RouteID, digitCount)
      .subscribe(
        (locations: LocationModel[]) => {
          this.currentLocationSubject = new BehaviorSubject<LocationModel[]>(
            locations
          );
          this.currentLocation = this.currentLocationSubject.asObservable();
          this.dataSource = new MatTableDataSource<LocationModel>(locations);
          this.setLoadingInProgress(false);
        },
        (err: HttpErrorResponse) => {
          this.setLoadingInProgress(false);
          this.currentLocationSubject.next(null);
        }
      );
  }

  async initialiseLocationException(
    digitCount: number,
    customerID: number,
    ActiveHourFrom: number,
    ActiveHourTo: number
  ) {
    this.setLoadingInProgress(true);
    await this.apiProvider
      .GetLocationException(
        this.RouteID,
        digitCount,
        customerID,
        ActiveHourFrom,
        ActiveHourTo
      )
      .subscribe(
        (locations: LocationModel[]) => {
          console.log(locations);
          this.currentLocationSubject = new BehaviorSubject<LocationModel[]>(
            locations
          );
          this.currentLocation = this.currentLocationSubject.asObservable();
          this.dataSource = new MatTableDataSource<LocationModel>(locations);
          this.setLoadingInProgress(false);
        },
        (err: HttpErrorResponse) => {
          this.setLoadingInProgress(false);
          this.currentLocationSubject.next(null);
        }
      );
  }
}
